<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="partner-tab-section">
          <div class="refined-header">
            <div>
              <h2 class="refined-title">Şirketler</h2>
              <p class="refined-subtitle">Şirket listesini filtreleyip yönetebilirsiniz</p>
            </div>
            <button type="button" class="refined-primary-btn" @click="openUpsertDialog()">
              <v-icon small class="mr-1">add</v-icon>
              Yeni Şirket Ekle
            </button>
          </div>

          <div class="refined-filters">
            <div class="refined-filter-item">
              <label class="refined-filter-label">Ara</label>
              <input
                v-model="search"
                type="text"
                class="refined-input"
                placeholder="Şirket adı"
                @input="loadCompanies"
              />
            </div>
          </div>

          <div class="refined-table-wrap">
            <div class="refined-table-scroll">
              <table class="refined-table">
                <thead>
                  <tr>
                    <th>Şirket Adı</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="2" class="refined-loading">
                      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                      Yükleniyor...
                    </td>
                  </tr>
                  <tr v-else-if="!companies.length">
                    <td colspan="2" class="refined-empty">Kayıt yok</td>
                  </tr>
                  <tr v-for="(item, i) in companies" :key="item.id || i" class="refined-row">
                    <td class="refined-cell-bold">{{ item.name }}</td>
                    <td>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <button type="button" class="refined-action-btn" v-on="on">İşlem</button>
                        </template>
                        <v-card class="refined-menu-card">
                          <div class="refined-menu-body">
                            <button type="button" class="refined-menu-btn refined-menu-btn-primary" @click="openUpsertDialog(item)">DÜZENLE</button>
                            <div class="refined-menu-divider"></div>
                            <button type="button" class="refined-menu-btn refined-menu-btn-error" @click="openDelete(item)">SİL</button>
                          </div>
                        </v-card>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="420" persistent>
      <v-card>
        <v-card-title class="headline">Silme Onayı</v-card-title>
        <v-card-text>
          <strong>{{ companyToDelete ? companyToDelete.name : '' }}</strong> kaydını silmek istediğinizden emin misiniz?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="deleteDialog = false" :disabled="deleting">İptal</v-btn>
          <v-btn color="error" @click="confirmDelete" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upsertDialog" max-width="620" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text primary elevation-2">
          <v-icon left color="white" size="28">business</v-icon>
          <span class="font-weight-bold">{{ upsertId ? 'Şirket Düzenle' : 'Yeni Şirket Ekle' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeUpsertDialog" :disabled="saving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 primary--text py-2">
                <v-icon left color="primary">tune</v-icon>
                Bilgiler
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-text-field
                  v-model="upsertName"
                  label="Şirket Adı"
                  outlined
                  dense
                  :disabled="saving"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeUpsertDialog" class="px-4" :disabled="saving">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="primary" depressed class="white--text px-4" :loading="saving" @click="saveUpsert">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import companiesApi from '@/api/companies';

export default {
  data() {
    return {
      search: '',
      loading: false,
      companies: [],
      deleteDialog: false,
      deleting: false,
      companyToDelete: null,
      upsertDialog: false,
      saving: false,
      upsertId: null,
      upsertName: '',
    };
  },
  methods: {
    async loadCompanies() {
      this.loading = true;
      try {
        const res = await companiesApi.getCompanies({ q: this.search || '' });
        this.companies = res && res.data ? res.data : [];
      } catch (e) {
        this.companies = [];
        this.$store.state.dialog = true;
        this.$store.state.message = 'Şirketler alınamadı.';
      } finally {
        this.loading = false;
      }
    },
    openUpsertDialog(item) {
      const isEdit = !!(item && item.id);
      this.upsertId = isEdit ? item.id : null;
      this.upsertName = isEdit ? (item.name || '') : '';
      this.upsertDialog = true;
    },
    closeUpsertDialog(force = false) {
      if (this.saving && !force) return;
      this.upsertDialog = false;
      this.upsertId = null;
      this.upsertName = '';
    },
    async saveUpsert() {
      const name = String(this.upsertName || '').trim();
      if (!name) return;
      this.saving = true;
      try {
        if (this.upsertId) {
          await companiesApi.putCompany(this.upsertId, { name });
        } else {
          await companiesApi.postCompany({ name });
        }
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydedildi.';
        this.closeUpsertDialog(true);
        await this.loadCompanies();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydetme sırasında hata oluştu.';
      } finally {
        this.saving = false;
      }
    },
    openDelete(item) {
      this.companyToDelete = item;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      if (!this.companyToDelete || !this.companyToDelete.id) return;
      this.deleting = true;
      try {
        await companiesApi.deleteCompany(this.companyToDelete.id);
        this.deleteDialog = false;
        this.$store.state.dialog = true;
        this.$store.state.message = 'Şirket silindi.';
        await this.loadCompanies();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Silme sırasında hata oluştu.';
      } finally {
        this.deleting = false;
        this.companyToDelete = null;
      }
    },
  },
  mounted() {
    this.loadCompanies();
  },
};
</script>

<style scoped>
.bank-modal {
  overflow: hidden;
}

.modern-card {
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.26) !important;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
  overflow: hidden;
}

.partner-tab-section {
  max-width: 80rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.refined-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.refined-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
}

.refined-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
}

.refined-primary-btn {
  display: inline-flex;
  align-items: center;
  background: #2563eb;
  color: #fff;
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
  transition: background 0.2s, box-shadow 0.2s;
}

.refined-primary-btn:hover {
  background: #1d4ed8;
}

.refined-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.refined-filter-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.refined-filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-input {
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  font-size: 0.875rem;
  color: #0f172a;
  min-width: 220px;
}

.refined-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.refined-table-wrap {
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-table-scroll {
  overflow-x: auto;
}

.refined-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.refined-table thead tr {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.refined-table th {
  padding: 1rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.refined-table tbody tr:hover {
  background: rgba(248, 250, 252, 0.7);
}

.refined-table td {
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  color: #475569;
}

.refined-cell-bold {
  font-weight: 600;
  color: #1e293b;
}

.refined-loading,
.refined-empty {
  text-align: center;
  padding: 2rem !important;
  color: #64748b;
}

.refined-action-btn {
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.refined-action-btn:hover {
  background: #1d4ed8;
}

.refined-menu-card {
  border-radius: 0.625rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-menu-body {
  padding: 0.5rem;
  min-width: 180px;
}

.refined-menu-btn {
  display: block;
  width: 100%;
  padding: 0.625rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s, filter 0.2s;
  margin-bottom: 0.375rem;
}

.refined-menu-btn:hover {
  opacity: 0.92;
  filter: brightness(1.05);
}

.refined-menu-btn-primary {
  background: #2563eb;
}

.refined-menu-btn-error {
  background: #dc2626;
}

.refined-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.5rem 0;
}

.refined-table th:last-child,
.refined-table td:last-child {
  text-align: right;
}
</style>
